import { Field, Form, Formik } from "formik";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import useSchema from "hooks/useSchema";
import Checkbox from "pages/_components/Checkbox";
import TextField from "pages/_components/fields/TextField";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import { goBack } from "connected-react-router";
import * as Yup from "yup";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { ServicePaymentSummaryBody } from "./components/SummaryBody";

const FORM_ID = "payments.service";

const initialValues = {
    enrollService: false,
    serviceAlias: "",
};

const ServicePaymentSumaryPage = () => {
    const { prepareData, servicePaymentTicket } = useSelector((state) => state.servicePayments);
    const { isCABpayment = false, fromScheduledServices = false } = prepareData;
    const joinService = !isCABpayment && !fromScheduledServices;
    const { stringRequired } = useSchema();
    const [adhesionData, setAdhesionData] = useState(initialValues);
    const { dispatch } = useConfirmTransaction(prepareData, servicePaymentTicket, `payments/services`);

    const validationSchema = Yup.object().shape({
        // eslint-disable-next-line no-confusing-arrow
        serviceAlias: Yup.string().when("enrollService", (enrollService, schema) =>
            enrollService ? stringRequired : schema,
        ),
    });

    const handleBack = () => {
        dispatch(servicePaymentsActions.resetPaymentForm());
        dispatch(goBack());
    };

    return (
        <>
            <Notification scopeToShow="sumaryServicePaymentPage" />
            <ResponsiveHeader id="payments.service.new" onClickBack={handleBack} />
            <MainContainer>
                <I18n id="payments.service.summary" />
                <ServicePaymentSummaryBody
                    companyName={prepareData.companyName}
                    amount={prepareData.amount}
                    expirationDate={prepareData.expirationDate}
                    accountLabel={prepareData.accountLabel}
                    details={prepareData.details}
                    operationId={prepareData.operationId}
                />
                <GridTable>
                    <GridTable.Container columns={12} columnsTemplate="fixed">
                        <GridTable.Data columnStart={2} columnWidth={10} flexDirection="column">
                            {joinService && !prepareData.idTransaction && (
                                <Formik
                                    enableReinitialize
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}>
                                    {({ values, setFieldValue }) => (
                                        <Form>
                                            <Field
                                                component={Checkbox}
                                                idForm={FORM_ID}
                                                name="enrollService"
                                                labelText={`${FORM_ID}.schedule`}
                                                onChange={(checked) =>
                                                    setAdhesionData((prevState) => {
                                                        if (!checked) {
                                                            setFieldValue("serviceAlias", "");
                                                            return {
                                                                serviceAlias: "",
                                                                enrollService: checked,
                                                            };
                                                        }
                                                        return {
                                                            ...prevState,
                                                            enrollService: checked,
                                                        };
                                                    })
                                                }
                                            />
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="serviceAlias"
                                                handleOnChange={(e) =>
                                                    setAdhesionData((prevState) => ({
                                                        ...prevState,
                                                        serviceAlias: e.target.value,
                                                    }))
                                                }
                                                disabled={!values.enrollService}
                                                hidePlaceholder
                                            />
                                        </Form>
                                    )}
                                </Formik>
                            )}
                            {/* <I18n id="" /> */}
                            <div className="container--alert" role="alert">
                                <div className="alert alert-info" style={{ margin: 0 }}>
                                    <CustomData
                                        icon="information_fill.svg"
                                        titleText="payments.service.reminder"
                                        titleTextType="I18N"
                                        keepSpaceIfNoValue={false}
                                    />
                                </div>
                            </div>
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                <GeneralCredentialForm
                    transactionData={{ ...prepareData, ...adhesionData }}
                    action={servicePaymentsActions.payService}
                    idActivity="rapipago.operation.confirm"
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

export default ServicePaymentSumaryPage;
